module.exports = __webpack_public_path__ + "img/2-1.34d2ead4.svg";